import { render, staticRenderFns } from "./tem-list.vue?vue&type=template&id=2cff0e0e&scoped=true"
import script from "./tem-list.vue?vue&type=script&lang=ts"
export * from "./tem-list.vue?vue&type=script&lang=ts"
import style0 from "./tem-list.vue?vue&type=style&index=0&id=2cff0e0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cff0e0e",
  null
  
)

export default component.exports